module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": _vm.color ? _vm.color : 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.closeCallback) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": _vm.closeCallback
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61cb6a94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toolbars/basic-toolbar.vue
// module id = 351
// module chunks = 0